import { email } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';

export default {
  props: ['existing', 'editable'],
  data() {
    return {
      defaultAddress: '',
      defaultEmailAddresses: {
        to: [],
        cc: [],
        bcc: []
      }
    };
  },
  validations: {
    defaultAddress: { email }
  },
  mounted() {
    if (this.existing === true) {
      this.defaultEmailAddresses = this.currentTemplate.defaultEmailAddresses;
    }
  },
  computed: {
    defaultAddressErrors() {
      const errors = [];
      if (!this.$v.defaultAddress.$dirty) return errors;
      !this.$v.defaultAddress.email &&
                errors.push('You must enter a valid from email address');
      return errors;
    },
    ...mapState('templates', ['currentTemplate'])
  },
  methods: {
    removeEmailAddress(itemToRemove, addressType) {
      if (itemToRemove !== undefined) {
        switch (addressType) {
          case 'To':
            this.defaultEmailAddresses.to.splice(itemToRemove, 1);
            break;
          case 'Cc':
            this.defaultEmailAddresses.cc.splice(itemToRemove, 1);
            break;
          case 'Bcc':
            this.defaultEmailAddresses.bcc.splice(itemToRemove, 1);
            break;
        }
      }
    },
    addEmailAddress(addressType) {
      if (this.defaultAddress === null || this.defaultAddress === '') {
        return;
      }

      if (this.$v.defaultAddress.$invalid) {
        return;
      }

      switch (addressType) {
        case 'To':
          this.defaultEmailAddresses.to.push(this.defaultAddress);
          this.defaultAddress = '';
          break;
        case 'Cc':
          this.defaultEmailAddresses.cc.push(this.defaultAddress);
          this.defaultAddress = '';
          break;
        case 'Bcc':
          this.defaultEmailAddresses.bcc.push(this.defaultAddress);
          this.defaultAddress = '';
          break;
      }
      this.$emit('newAddresses', this.defaultEmailAddresses);
    }
  }
};
